import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GeneralService } from '../shared/services/general.service';
import { LoadGeneralComponent } from '../shared/components-generals/load-general/load-general.component';
import { InputGeneral } from '../shared/inputs/input-general/input-general';
import { AuthService } from '../shared/services/auth.service';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-login-aux',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    LoadGeneralComponent,
    InputGeneral,
  ],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  userId: number = 0;
  loginattempts: number = 0;

  isLoading: boolean = false;
  loginForm: FormGroup = new FormGroup({
    username: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    password: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
  });
  public mobile = false;
  private breakpointSubscription!: Subscription;

  constructor(
    public router: Router,
    public authService: AuthService,
    private generalService: GeneralService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.checkScreenSize();
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  private checkScreenSize(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe((result) => {
        this.mobile = result.matches;
      });
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }

    this.isLoading = true;

    const { username, password } = this.loginForm.value as {
      username: string;
      password: string;
    };

    const loginRequest = {
      u: username,
      p: password,
      v: 1,
    };

    this.authService.login(loginRequest).subscribe({
      next: (response) => {
        this.isLoading = true;

        if (response) {
          this.isLoading = false;
          if (response.Result !== 'CC00FF') {
            this.generalService.viewSnacAlert(
              response.Data[0].Messages[0],
              'alert',
              response.Message,
            );
          } else {
            localStorage.setItem('token', response.Data);
            localStorage.setItem('Username', response.Extra.Username);
            this.router.navigate(['/home']);
          }
        }
      },
    });
  }

  public getControl(formGroup: FormGroup, key: string): FormControl {
    return formGroup.get(key) as FormControl;
  }
}
